import '../../libs/jquery.mask';

export class FakeInputDate {
    constructor(el, withCalendar = false) {
        this.domInput = el instanceof jQuery ? el[0] : el;
        if (!this.domInput.hasAttribute('data-date-pattern')) {
            throw new Error('Missing attribute data-date-pattern on field ' + Hop.describeDomElement(el));
        }

        this.optCalendar = Object.assign({}, withCalendar);
        this.id = this.domInput.getAttribute('id');
        this.calendar = null;

        this.createClone();

        this.domInput.setAttribute('tabindex', '-1');

        this.updateRequired();

        this.domInput.parentNode.style.position = 'relative';

        Object.assign(this.domInput.style, {
            'position': 'absolute',
            'top': 0,
            'left': 0,
            'z-index': -1,
        });

        this.domInput.setAttribute('data-id', this.domInput.getAttribute('id'));
        this.domInput.removeAttribute('id');
        this.domInput.removeAttribute('pattern');
        this.domInput.parentNode.insertBefore(this.domClone, this.domInput.nextSibling);

        Hop.events.trigger('initElementTooltip', this.domClone);

        const inputMask = this.domClone.getAttribute('data-input-mask');
        if ($(this.domClone).mask && inputMask) {
            $(this.domClone).mask(inputMask);
        }

        /* istanbul ignore else  */
        if (this.domInput.value !== '') {
            this.setInitCloneDate();
        }

        this.domInput.classList.add('fakeDateInit');

        this.setLimitDate();

        /* istanbul ignore if  */
        if (Hop.FormCalendar && this.optCalendar) {
            if (!this.optCalendar.yearRange) {
                const today = new Date();
                const minDate = this.optCalendar.minDate;
                const maxDate = this.optCalendar.maxDate;
                const lowerBound = minDate ? minDate.getFullYear() : today.getFullYear() - 100;
                const upperBound = maxDate ? maxDate.getFullYear() : today.getFullYear() + 2;
                this.optCalendar.yearRange = [lowerBound, upperBound];
            }

            this.calendar = new Hop.FormCalendar(this.domInput, this.domClone, this.optCalendar);
        }

        this.setHandlers();
    }

    createClone() {
        this.domClone = document.createElement('input');
        this.domClone.setAttribute('type', 'text');
        this.domClone.classList.add('fakeDate');
        this.domClone.setAttribute('name', 'fake-' + this.domInput.getAttribute('name'));
        this.domClone.setAttribute('id', this.domInput.getAttribute('id'));
        this.domClone.value = this.domInput.value;

        /* istanbul ignore else  */
        if (this.domInput.hasAttribute('class')) {
            this.updateClassNames();
        }

        /* istanbul ignore else  */
        if (this.domInput.hasAttribute('placeholder')) {
            this.domClone.setAttribute('placeholder', this.domInput.getAttribute('placeholder'));
        }

        /* istanbul ignore else  */
        if (this.domInput.hasAttribute('pattern')) {
            this.domClone.setAttribute('pattern', this.domInput.getAttribute('pattern'));
        }

        /* istanbul ignore else  */
        if (this.domInput.disabled) {
            this.updateDisabled();
        }

        /* istanbul ignore else  */
        if (this.domInput.hasAttribute('data-title')) {
            this.domClone.setAttribute('data-title', this.domInput.getAttribute('data-title'));
        }

        /* istanbul ignore else  */
        if (this.domInput.hasAttribute('data-date-pattern')) {
            this.domClone.setAttribute('data-date-pattern', this.domInput.getAttribute('data-date-pattern'));
        }

        /* istanbul ignore else  */
        if (this.domInput.hasAttribute('data-placement')) {
            this.domClone.setAttribute('data-placement', this.domInput.getAttribute('data-placement'));
        }

        if (this.domInput.hasAttribute('data-input-mask')) {
            this.domClone.setAttribute('data-input-mask', this.domInput.getAttribute('data-input-mask'));
        }

        ['data-content', 'data-trigger', 'data-toggle'].forEach((attr) => {
            if (this.domInput.hasAttribute(attr)) {
                this.domClone.setAttribute(attr, this.domInput.getAttribute(attr));
                this.domInput.removeAttribute(attr);
            }
        });
    }

    setLimitDate() {
        if (this.domInput.getAttribute('data-min-date')) {
            this.optCalendar.minDate = this.domInput.getAttribute('data-min-date');
        }
        if (this.domInput.getAttribute('data-max-date')) {
            this.optCalendar.maxDate = this.domInput.getAttribute('data-max-date');
        }
        if (this.domInput.getAttribute('data-min-years')) {
            this.optCalendar.minYears = this.domInput.getAttribute('data-min-years');
        }

        /* istanbul ignore else  */
        if (this.optCalendar.minDate) {
            if (this.optCalendar.minDate === 'today') {
                const today = new Date();
                this.optCalendar.minDate = new Date();
                this.optCalendar.defaultDate = new Date(new Date().setDate(today.getDate() + 1));
            } else if (this.optCalendar.minDate === 'tomorrow') {
                const today = new Date();
                this.optCalendar.minDate = new Date();
                this.optCalendar.minDate.setDate(today.getDate() + 1);
                this.optCalendar.defaultDate = new Date(new Date().setDate(today.getDate() + 2));
            } else {
                this.optCalendar.minDate = new Date(this.optCalendar.minDate);
                this.optCalendar.defaultDate = new Date(new Date().setDate(this.optCalendar.minDate.getDate() + 1));
            }
            this.optCalendar.minDate = new Date(this.optCalendar.minDate.setHours(0, 0, 0, 0));
        }

        /* istanbul ignore else  */
        if (this.optCalendar.maxDate) {
            if (this.optCalendar.maxDate === 'today') {
                this.optCalendar.maxDate = new Date();
            } else if (this.optCalendar.maxDate === 'tomorrow') {
                const today = new Date();
                this.optCalendar.maxDate = new Date();
                this.optCalendar.maxDate.setDate(today.getDate() + 1);
            } else {
                this.optCalendar.maxDate = new Date(this.optCalendar.maxDate);
            }
            this.optCalendar.maxDate = new Date(this.optCalendar.maxDate.setHours(23, 59, 59, 999));
        }

        /* istanbul ignore else  */
        if (this.optCalendar.minYears) {
            const today = new Date();
            const maxDate = new Date(today.setFullYear(today.getFullYear() - this.optCalendar.minYears));
            this.optCalendar.defaultDate = maxDate;
            this.optCalendar.maxDate = maxDate;
            this.optCalendar.maxDate = new Date(this.optCalendar.maxDate.setHours(23, 59, 59, 999));
        }
    }

    setInitCloneDate() {
        const inputValue = this.domInput.value;
        if (inputValue) {
            // Fix for date value when timezone is different
            const dateArr = inputValue.split('-').map((value) => parseInt(value, 10));
            const date = new Date(dateArr[0], dateArr[1] - 1, dateArr[2]);

            this.domClone.value = Hop.formatDate(date, {
                pattern: this.domClone.getAttribute('data-date-pattern'),
            });
        }
    }

    setHandlers() {
        $(this.domClone).on('blur', (e) => {
            this.updateInput(e);
        });

        $(this.domClone).on('input', (e) => {
            this.updateInput(e);
        });

        // Bind update event from original date input, and propagate event to the fake visible element
        // in the DOM.
        $(this.domInput).on('change', (e) => {
            this._propragateDomInputUpdate(e, false);
        });

        $(this.domInput).on('input', (e, details) => {
            if (!details || details.origin !== 'domClone') {
                this._propragateDomInputUpdate(e, true);
            }
        });

        // test only for jsdom
        /* istanbul ignore if  */
        if (window.MutationObserver || window.WebKitMutationObserver) {
            const MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

            this.observer = new MutationObserver((mutations) => {
                let className = false;
                let required = false;
                let ariaInvalid = false;
                let disabled = false;

                for (let i = 0; i < mutations.length; i++) {
                    if (mutations[i].attributeName === 'class') {
                        className = true;
                    }

                    if (mutations[i].attributeName === 'required') {
                        required = true;
                    }

                    if (mutations[i].attributeName === 'aria-invalid') {
                        ariaInvalid = true;
                    }

                    if (mutations[i].attributeName === 'disabled') {
                        disabled = true;
                    }
                }
                if (className) {
                    this.updateClassNames();
                }

                if (required) {
                    this.updateRequired();
                }

                if (ariaInvalid) {
                    this.updateAriaInvalid();
                }

                if (disabled) {
                    this.updateDisabled();
                }
            });

            this.observer.observe(this.domInput, {
                attributes: true,
            });
        }

        $(this.domInput).on('destroy', this.destroy.bind(this));
    }

    _propragateDomInputUpdate(e, silent = false) {
        this.setInitCloneDate();
        this.checkValidLimitDate();

        if (!silent) {
            // Since the domInput is a fake input invisible on screen, propagate change event
            // to the "fake" input that is really in the DOM.
            $(this.domClone).trigger(e.type);
        }
    }

    updateAriaInvalid() {
        this.domClone.setAttribute('aria-invalid', this.domInput.getAttribute('aria-invalid'));
    }

    updateInput(e) {
        if (typeof this.domClone.checkValidity !== 'function' || this.domClone.checkValidity()) {
            const value = this.domClone.value;
            if (value) {
                const pattern = this.domClone.getAttribute('data-date-pattern');
                const cloneDate = Hop.parseDateFromPattern(value, pattern);
                this.domInput.value = Hop.toInputDate(cloneDate);
            } else {
                this.domInput.value = null;
            }
        }

        const type = e.type;
        const blur = type === 'blur';
        const click = type === 'click';
        if (blur || click) {
            $(this.domInput).trigger(type, {
                origin: 'domClone',
            });

            if (blur) {
                this.domInput.blur();
            }
        }

        this.checkValidLimitDate();
    }

    checkValidLimitDate() {
        if (this.domClone.checkValidity() && (this.optCalendar.minDate || this.optCalendar.maxDate)) {
            const inputValue = this.domInput.value;
            if (this.optCalendar.maxDate) {
                if (new Date(inputValue) > this.optCalendar.maxDate) {
                    this.domInput.setCustomValidity(Hop.message('generic.calendar.error.maxdate.invalid', Hop.formatDate(this.optCalendar.maxDate)));
                } else {
                    this.domInput.setCustomValidity('');
                }
            } else if (this.optCalendar.minDate) {
                if (new Date(inputValue) < this.optCalendar.minDate) {
                    this.domInput.setCustomValidity(Hop.message('generic.calendar.error.mindate.invalid', Hop.formatDate(this.optCalendar.minDate)));
                } else {
                    this.domInput.setCustomValidity('');
                }
            }
        }
        this.updateAriaInvalid();
    }

    updateClassNames() {
        this.updateAttr('className');
    }

    updateRequired() {
        this.updateAttr('required');
    }

    updateDisabled() {
        this.updateAttr('disabled');
    }

    updateAttr(attr) {
        if (this.domClone && this.domInput) {
            this.domClone[attr] = this.domInput[attr];
        }
    }

    destroy() {
        this.domInput.removeAttribute('tabindex');
        if (this.domClone.required) {
            this.domInput.required = true;
        } else {
            this.domInput.required = false;
        }
        this.domClone.parentNode.removeChild(this.domClone);
        if (this.calendar !== null) {
            this.calendar.destroy();
        }
        delete this.domClone;
    }
}
